import React from "react";
import { Link } from "react-router-dom";

const MobileNavMenu = () => {
  return (
    <nav className="offcanvasNavigation" id="offcanvas-navigation">
      <ul>
        <li>
          <Link to={process.env.PUBLIC_URL + "/"}>Home</Link>
        </li>
        <li>
          <Link to={process.env.PUBLIC_URL + "/portfolio"}>Portfolio</Link>
        </li>
        <li>
          <Link to={process.env.PUBLIC_URL + "/about"}>About Us</Link>
        </li>
        <li>
          <Link to={process.env.PUBLIC_URL + "/contact"}>Contact</Link>
        </li>
        <li>
          <Link to={process.env.PUBLIC_URL + "/swap"}>Swap</Link>
        </li>
      </ul>
    </nav>
  );
};

export default MobileNavMenu;
